import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React from 'react';
import { Switch } from 'react-router-dom';
import ROUTES from 'routes/routeConstants';
import { CompanyRoleEnum, RoleEnum } from 'types/user';
import asyncComponent from 'utils/asyncComponent';

import AccountingDetail from './AccountingDetail';
import Accountings from './Accountings';
import Appointments from './Appointments';
import NotaryAppointments from './Appointments/components/NotaryAppointments';
import Company from './Company/CompanyVer2';
import PageNotFound from './Errors/PageNotFound';
import ManageLocations from './ManageLocations';
import { PrivateRoute, RoleProtectedRoute } from './routing';
import ServiceTypes from './ServiceTypes';
import SystemLog from './SystemLog';
import Transaction from './Transaction';
import Transactions from './Transactions';

const UserWizard = asyncComponent(() => import('components/UserWizard'));
const Dashboard = asyncComponent(() => import('./Dashboard'));
const Users = asyncComponent(() => import('routes/Users'));
const Profile = asyncComponent(() => import('routes/Profile'));

const App: React.FC<{ match: any }> = () => {
  const user = useCurrentLoggedInUser();
  // const userCompanyRole = user.companyRole;
  const userManagementAccess =
    user.usersLocations?.some((uL) => uL.manageUsersPermission) ||
    user.role === RoleEnum.ADMIN ||
    user.companyRole === CompanyRoleEnum.ADMIN;
  return (
    <div className='gx-content-container'>
      <Switch>
        <PrivateRoute exact path={ROUTES.USER_WIZARD} component={UserWizard} />
        <RoleProtectedRoute
          allow={[RoleEnum.ADMIN, RoleEnum.CLIENT]}
          blocked={!userManagementAccess}
          exact
          path={ROUTES.USERS}
          component={Users}
        />
        <PrivateRoute exact path={ROUTES.PROFILE} component={Profile} />
        <RoleProtectedRoute
          allow={[RoleEnum.ADMIN, RoleEnum.CLIENT]}
          exact
          path={ROUTES.TRANSACTIONS}
          component={Transactions}
        />
        <RoleProtectedRoute allow={[RoleEnum.CLIENT]} exact path={ROUTES.TRANSACTION_CREATE} component={Transaction} />
        <RoleProtectedRoute allow={[RoleEnum.CLIENT]} exact path={ROUTES.COMPANY} component={Company} />
        <RoleProtectedRoute
          allow={[RoleEnum.ADMIN, RoleEnum.CLIENT]}
          exact
          path={ROUTES.TRANSACTION_DETAIL}
          component={Transaction}
        />
        <RoleProtectedRoute allow={[RoleEnum.ADMIN]} exact path={ROUTES.APPOINTMENTS} component={Appointments} />
        <RoleProtectedRoute allow={[RoleEnum.ADMIN]} exact path={ROUTES.SERVICE_TYPES} component={ServiceTypes} />
        <RoleProtectedRoute
          allow={[RoleEnum.NOTARY]}
          exact
          path={ROUTES.HISTORY_APPOINTMENTS}
          component={NotaryAppointments}
        />
        <RoleProtectedRoute
          allow={[RoleEnum.NOTARY]}
          exact
          path={ROUTES.ACTIVE_APPOINTMENTS}
          component={NotaryAppointments}
        />
        <PrivateRoute exact path={ROUTES.ACCOUNTINGS} component={Accountings} />
        <PrivateRoute exact path={ROUTES.ACCOUNTING_DETAIL} component={AccountingDetail} />
        <RoleProtectedRoute allow={[RoleEnum.ADMIN]} exact path={ROUTES.SYSTEM_LOG} component={SystemLog} />
        <RoleProtectedRoute
          allow={[RoleEnum.CLIENT]}
          exact
          path={ROUTES.COMPANY_LOCATION}
          component={ManageLocations}
        />
        <PrivateRoute path='/' exact component={Dashboard} />
        <PrivateRoute path='/' component={PageNotFound} failureRedirect={ROUTES.PAGE_NOT_FOUND} />
      </Switch>
    </div>
  );
};
export default App;
